// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_cRE","cls2":"ZeroState-cls2_cFu ZeroState-cls1_cRE"};